import { DELETE } from "../../APiHelper/API"

export const deleteReferee = (referee_id, onSuccess, onError) => {
    DELETE(`/api/v1/leagues/referee/${referee_id}`, onSuccess, onError)
}